import { ToParentPostMessage } from '../../enums';
import { LaunchData } from '../../models';
import { IntegrationBase } from './base';
import { env } from '../../environment';

export class CashierIntegration extends IntegrationBase {

  public generateLaunchUrl(data: LaunchData): string {

    const {
      partnerId, userId, currency, currencySymbol, culture, devMode, playerExternalId, exitUrl, platformId,
      partnerExternalId, showCheckButton, hideThemeSwitcher, dontShowPascalLoader, betshopId, businessUnitId, userType
    } = data;

    const urlString = devMode ? 'https://localhost:5005/' : `${env.origin}/cashier/`;

    const url = new URL(urlString);

    url.searchParams.set('partnerId', `${partnerId}`);
    url.searchParams.set('currency', `${currency}`);
    url.searchParams.set('currencySymbol', `${decodeURIComponent(currencySymbol)}`);
    url.searchParams.set('culture', `${culture}`);
    url.searchParams.set('userId', `${userId}`);
    url.searchParams.set('playerExternalId', `${playerExternalId}`);
    
    if (exitUrl) {
      url.searchParams.set('exitUrl', encodeURIComponent(exitUrl));
    }
    if (platformId) {
      url.searchParams.set('platformId', `${platformId}`);
    }
    if (partnerExternalId) {
      url.searchParams.set('partnerExternalId', `${partnerExternalId}`);
    }
    if (showCheckButton) {
      url.searchParams.set('showCheckButton', `${showCheckButton}`);
    }
    if (hideThemeSwitcher) {
      url.searchParams.set('hideThemeSwitcher', `${hideThemeSwitcher}`);
    }
    if (dontShowPascalLoader) {
      url.searchParams.set('dontShowPascalLoader', `${dontShowPascalLoader}`);
    }
    if (betshopId) {
      url.searchParams.set('betshopId', `${betshopId}`);
    }
    if (businessUnitId) {
      url.searchParams.set('businessUnitId', `${businessUnitId}`);
    }
    if (userType) {
      url.searchParams.set('userType', `${userType}`);
    }

    return url.toString();
  }

  public handleGameLoaded() {
    this.rootStore.postMessageStore.sendParentMessage({ type: ToParentPostMessage.PgLoaded });
  }

  public handleErrorReceived() {
    this.rootStore.postMessageStore.sendParentMessage({ type: ToParentPostMessage.ConnectionLost });
  }

}
